import { CommonModule } from '@angular/common';
import { Component, ElementRef, EventEmitter, HostListener, Input, Output } from '@angular/core';

export interface CustomSelectOption {
  key: string;
  pageName: string;
}

@Component({
  selector: 'app-custom-select',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './custom-select.html',
  styleUrl: './custom-select.scss',
})
export class CustomSelectComponent {
  @Input() options: CustomSelectOption[] = [];
  @Input() value: string | null = null;
  @Input() placeholder = 'All';
  @Input() showPlaceholderOption = true;
  @Input() ariaLabel = '';

  @Output() valueChange = new EventEmitter<string | null>();

  isOpen = false;

  constructor(private elementRef: ElementRef<HTMLElement>) {}

  get selectedLabel(): string {
    const match = this.options.find(option => option.key === this.value);
    return match ? match.pageName : this.placeholder;
  }

  toggle(): void {
    this.isOpen = !this.isOpen;
  }

  select(key: string | null): void {
    this.valueChange.emit(key);
    this.isOpen = false;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    if (!this.elementRef.nativeElement.contains(event.target as Node)) {
      this.isOpen = false;
    }
  }

  @HostListener('document:keydown.escape')
  onEscape(): void {
    this.isOpen = false;
  }
}
